import { configureStore } from '@reduxjs/toolkit'
import baseApi from './redux/api/baseApi'
import authReducer from './redux/slice/authSlice'
import userReducer from './redux/slice/userSlice'
import pipelineApi from './redux/api/pipelineApi'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [pipelineApi.reducerPath]: pipelineApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware).concat(pipelineApi.middleware),
})
